import { getBaseUrl, Microservice } from "../constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface GenerateTwoFASKRequest {
  email: string;
}
const generateTwoFASecretKey = async ({ email }: GenerateTwoFASKRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/auth/generate-two-factor-secret-key`,
      { email },
      { withCredentials: true },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    (e as Error).message = message;
    throw e;
  }
};

export default generateTwoFASecretKey;
